import { Dialog as BaseDialog } from '@base-ui/react';

import { useHandle } from './Dialog.hooks';
import { DialogActions } from './DialogActions';
import { DialogBody } from './DialogBody';
import { DialogHeader } from './DialogHeader';

export const Dialog = {
  Root: BaseDialog.Root,
  Trigger: BaseDialog.Trigger,
  Body: DialogBody,
  Header: DialogHeader,
  Actions: DialogActions,
  Close: BaseDialog.Close,
  useHandle,
};
